import CartButton from '@/components/cart_button'
import ResourceSection from '@/components/resources_section.js'
import AttributeSection from '@/components/attribute_section.js'
import parse from 'html-react-parser'; 
import  Script from  'next/script';
import CertIcons from "@/components/cert_icons.js"



export  const _cartButton = (_classes, {primarySpecSheet, cartActive, itemInCart, cart, product }) => { 
   return(  <CartButton 
    cartActive={cartActive}
    itemInCart={itemInCart}
    cart={cart}
    product={product}
    _classes={_classes}
     />
  )
}

export  const _resourceSection = (_classes, { product, config, resource_display }) => { 
   return(  
     <ResourceSection 
       downloads={product.downloads}
       product={product}
       config={config}
       resource_display={resource_display }
       _classes={_classes}
      />
   )
}

export const _configuratorLink = (_classes, label, {product, config}) => {

  return ( 
    <>
     {product.configuratorExists &&

     <a href="#lex-cms-configurator-app" className={`${_classes}`}>{label || 'Configurator'}</a>
     }
    </>
  )

}


export  const _attributeSection = (_classes, { product }) => { 
   return(  
     <AttributeSection
       attributes={product.attributes}
       _classes={_classes}
      />
   )
}
export const _certIcons = (_classes, {product}) => {

  return (
    <CertIcons product={product} _classes={_classes } />
    
   )
}


export const _inlineScript = (script) => {

  return (
    <Script strategy={'afterInteractive'}>{script}</Script>
  )

}



  
 export  const renderAtKey = (product, key) => {
    let html = "" 
    product.product_page_customizations[key]?.forEach((d, i) =>  {
      html +=  d;
    })
    return html;
  }

 export  const positionHTML = (position, area='button_area',  product_opts) =>  {
    if (product_opts.product.product_page_customizations &&  product_opts.product.product_page_customizations[`${area}_${position}`]) {
      let html =  renderAtKey(product_opts.product, `${area}_${position}`)
      return (
        parse(html, {replace(domNode) { 
          if (domNode.name === 'template' &&  domNode?.attribs?.id === 'lexcms-custom-cart-button' ){
            return  _cartButton(domNode.attribs.class, product_opts)
          }
          else if (domNode.name === 'template' &&  domNode?.attribs?.id === 'lexcms-resources-list' ){
            return  _resourceSection(domNode.attribs.class, product_opts)
          }
          else if (domNode.name === 'template' &&  domNode?.attribs?.id === 'lexcms-attributes-list' ){
            return  _attributeSection(domNode.attribs.class, product_opts)
          }
          else if (domNode.name === 'template' &&  domNode?.attribs?.id === 'lex-cms-configurator-app' ){
            let label = domNode?.children?.[0]?.data 
            return  _configuratorLink(domNode.attribs.class, label,  product_opts)
          }

          else if (domNode.name === 'template' &&  domNode?.attribs?.id === 'lexcms-certification-icons' ){
            return  _certIcons(domNode.attribs.class,  product_opts)
          }
          else if (domNode.name === 'script') {
            const rawScript = domNode.children
              .map(child => child.data)
              .join('');

            return _inlineScript(rawScript) 
          }
        }}
        ) 
      )
    }
  }
 
  

